export const PHONE_NUMBERS = {
  SURINAME: "+597436950",
  NETHERLANDS: "+31707113625",
  CURACAO: "+31707113625",
};
